<template>
    <div class="navbar-container d-flex content align-items-center pr-1">
        <!-- Nav Menu Toggler -->

        <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link class="nav-link" @click="toggleVerticalMenuActive">
                    <span class="saysimple-icon hamburger large" />
                </b-link>
            </li>
        </ul>

        <!-- Left Col -->
        <div class="align-items-center flex-grow-1 d-flex">
            <b-img
                id="top-bar-logo"
                center
                src="https://mfe.saysimple.io/static/images/logos/saysimple-logo-dark.svg"
            ></b-img>
        </div>

        <!-- Right Col -->
        <b-navbar-nav class="nav align-items-center ml-auto">
            <a :href="$t('qr-link-generator.url')" class="d-none d-md-block" target="_blank">
                <b-avatar
                    v-b-tooltip.hover.bottom="$t('qr-link-generator.tooltip')"
                    class="avatar-link-button mr-1"
                    rounded
                >
                    <font-awesome-icon :icon="['fass', 'qrcode']" />
                </b-avatar>
            </a>

            <release-notes-button />

            <b-nav-item-dropdown
                class="dropdown-user"
                right
                toggle-class="d-flex align-items-center dropdown-user-link px-0"
            >
                <template #button-content>
                    <b-avatar
                        id="navbar-user-dropdown"
                        :badge-variant="resolveUserStatus(onlineStatus)"
                        :src="profilePicture"
                        :text="userName"
                        badge
                        badge-offset="-3px"
                        class="badge-minimal round-large"
                        size="38"
                    />
                </template>

                <b-dropdown-item :to="{ name: 'settings-account' }" link-class="d-flex align-items-center">
                    <font-awesome-icon class="mr-50" icon="user" />
                    <span>{{ $t("settings.account.My account") }}</span>
                </b-dropdown-item>

                <b-dropdown-divider />

                <b-dropdown-group id="dropdown-group-1" :header="$t('Status')">
                    <b-dropdown-item :disabled="onlineStatus === 'available'" @click="onlineStatus = 'available'">
                        <span class="bullet bullet-sm mr-1 bullet-success"></span>{{ $t("Available") }}
                    </b-dropdown-item>
                    <b-dropdown-item :disabled="onlineStatus === 'unavailable'" @click="onlineStatus = 'unavailable'">
                        <span class="bullet bullet-sm mr-1 bullet-warning"></span>{{ $t("Unavailable") }}
                    </b-dropdown-item>
                </b-dropdown-group>

                <b-dropdown-divider v-if="tourHasSteps" class="d-none d-sm-block" />

                <b-dropdown-item
                    v-if="tourHasSteps"
                    :disabled="tourInProgress"
                    link-class="d-none d-sm-flex align-items-center"
                    @click="restartTour"
                >
                    <font-awesome-icon class="mr-50" icon="forward-step" />
                    <span>{{ $t("tour.start") }}</span>
                </b-dropdown-item>

                <b-dropdown-divider />

                <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
                    <font-awesome-icon class="mr-50" icon="sign-out-alt" />
                    <span>{{ $t("auth.Logout") }}</span>
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
    </div>
</template>

<script>
import {
    BAvatar,
    BButton,
    BCardText,
    BDropdownDivider,
    BDropdownGroup,
    BDropdownItem,
    BImg,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    VBTooltip,
} from "bootstrap-vue";
import Locale from "@/layouts/components/navbar/locale";
import ReleaseNotesButton from "@/layouts/components/release-notes/releaseNotesButton";
import { initialAbility } from "@/libs/acl/config";
import { avatarText } from "@core/utils/filter";
import useOnlineStatus from "@/composables/useOnlineStatus";
import { resolveInitials, resolveUserStatus } from "@/utils/users";
import { getUserData } from "@/auth/getUserData";
import useTour from "@/composables/useTour";
import useUserSettings from "@/composables/useUserSettings";

export default {
    components: {
        BButton,
        BLink,
        BNavbarNav,
        BNavItemDropdown,
        BDropdownItem,
        BDropdownGroup,
        BDropdownDivider,
        BAvatar,
        BCardText,
        BImg,

        // Navbar Components
        Locale,
        ReleaseNotesButton,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            avatarText,
            userName: resolveInitials(getUserData().name),
        };
    },
    methods: {
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });

            // Reset ability
            this.$ability.update(initialAbility);
        },
    },
    setup() {
        const { onlineStatus } = useOnlineStatus();
        const { restartTour, hasSteps: tourHasSteps, inProgress: tourInProgress } = useTour("inbox");
        const { profilePicture } = useUserSettings();

        return {
            resolveUserStatus,
            resolveInitials,
            onlineStatus,
            profilePicture,

            // TOUR
            restartTour,
            tourHasSteps,
            tourInProgress,
        };
    },
};
</script>
